module.exports = __webpack_public_path__ + "static/ecosystem-6474dc7d801595d88a60bebb652f7f16.svg";